/**
 * Cross-case linkage rows may repeat for the same remote case–node pair (multiple matched indicators).
 * UI and badge counts use one entry per unique (otherCaseId, otherInvestigationId).
 */

function linkageCaseNodeKey(link) {
  const caseId = link?.otherCaseId;
  const invId = link?.otherInvestigationId;
  if (caseId == null || caseId === '' || invId == null || invId === '') return null;
  return `${String(caseId)}:${String(invId)}`;
}

/**
 * Collapse raw linkage rows to one entry per remote case–node pair.
 */
export function dedupeLinkagesByCaseNode(links) {
  if (!Array.isArray(links) || links.length === 0) return [];

  const byCaseNode = new Map();
  for (const link of links) {
    const key = linkageCaseNodeKey(link);
    if (!key) continue;
    if (!byCaseNode.has(key)) {
      byCaseNode.set(key, { ...link });
      continue;
    }
    const existing = byCaseNode.get(key);
    if (!readLinkageField(existing, 'otherInvestigationTarget', 'other_investigation_target')
        && readLinkageField(link, 'otherInvestigationTarget', 'other_investigation_target')) {
      existing.otherInvestigationTarget = link.otherInvestigationTarget ?? link.other_investigation_target;
    }
    if (!readLinkageField(existing, 'otherCaseTarget', 'other_case_target')
        && readLinkageField(link, 'otherCaseTarget', 'other_case_target')) {
      existing.otherCaseTarget = link.otherCaseTarget ?? link.other_case_target;
    }
  }

  return Array.from(byCaseNode.values());
}

function readLinkageField(link, camel, snake) {
  const v = link?.[camel] ?? link?.[snake];
  return v == null || v === '' ? '' : String(v);
}

/** @deprecated Use {@link dedupeLinkagesByCaseNode}. */
export const dedupeLinkagesByInvestigation = dedupeLinkagesByCaseNode;

export function uniqueLinkageCaseNodeCount(links) {
  return dedupeLinkagesByCaseNode(links).length;
}

/** @deprecated Use {@link uniqueLinkageCaseNodeCount}. */
export const uniqueLinkageInvestigationCount = uniqueLinkageCaseNodeCount;

export function linkageCaseNodeRowKey(link) {
  return linkageCaseNodeKey(link) ?? String(link?.otherInvestigationId ?? '');
}
